export default "__VITE_ASSET__6f939f40__"